import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { initializeFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize App Check (reCAPTCHA v3)
// Enable debug token in development for localhost
if (import.meta.env.DEV) {
  // @ts-expect-error — Firebase App Check debug provider
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true
}

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY
if (recaptchaSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  })
}

// Initialize services
export const auth = getAuth(app)
// ignoreUndefinedProperties lets updateDoc tolerate nested `undefined` — needed
// when write payloads include legacy objects missing newly-added optional fields.
export const db = initializeFirestore(app, { ignoreUndefinedProperties: true })
export const storage = getStorage(app)

export default app
